// extracted by mini-css-extract-plugin
export var hideOnMobile = "styles-module--hideOnMobile--1yJAY";
export var headlineContainer = "styles-module--headlineContainer--ItWRM";
export var hiddenAnker = "styles-module--hiddenAnker--3qU5C";
export var wrapper = "styles-module--wrapper--1BrdK";
export var iconWrapper = "styles-module--iconWrapper--t0PSB";
export var hasAnker = "styles-module--hasAnker--21uKQ";